function injectExperienceDateMessage() {
  const dateParam = new URLSearchParams(window.location.search).get("date");
  if (!dateParam) return;

  const decodedDate = decodeURIComponent(dateParam).trim();
  const ticketType = sessionStorage.getItem("ticketType");

  const inject = () => {
    if (document.querySelector(".experience-selected-message")) return;

    const target = document.querySelector(".exp__dd-btn");
    if (target) {
      const messageDiv = document.createElement("div");
      messageDiv.classList.add("experience-selected-message");
      messageDiv.innerHTML = `<p style="margin-bottom: 10px; font-size: 1.1rem; color: #7b2525;">
        Your selected ${ticketType} date is:<br/><strong>${decodedDate}</strong>
      </p>`;
      target.parentNode.insertBefore(messageDiv, target);
      console.log("✅ Date message injected");
    }
  };

  const waitForTargetAndObserve = () => {
    const target = document.querySelector(".exp__dd-btn");
    if (target && target.parentNode) {
      inject(); // Initial inject

      const observer = new MutationObserver(() => {
        inject();
      });

      observer.observe(target.parentNode, {
        childList: true,
        subtree: true,
      });

      console.log("👀 MutationObserver attached");
    } else {
      console.log("⏳ Waiting for .exp__dd-btn...");
      setTimeout(waitForTargetAndObserve, 300);
    }
  };

  waitForTargetAndObserve();
}

document.addEventListener("DOMContentLoaded", injectExperienceDateMessage);